import Gravity from 'Gravity';

const initContentHubPage = () => {
    const contentHubPage = document.body.classList.contains('35years');

    if (!contentHubPage) {
        return;
    }

    document.body.classList.add('content-hub');

    function updatePadding() {
        const windowWidth = window.innerWidth;
        const padding = 40;
        const maxWidth = 1024;
        const strategiesSectionHeight = document.querySelector('.content-hub__strategies').offsetHeight;
        const lastSectionSpace = document.querySelector('.content-hub__grid-layout-last-section');

        if (windowWidth > maxWidth) {
            lastSectionSpace.style.paddingBottom = `unset`;
        } else {
            lastSectionSpace.style.paddingBottom = `${strategiesSectionHeight + padding}px`;
        }
    }

    window.addEventListener('load', updatePadding);
    window.addEventListener('resize', Gravity.debounce(updatePadding, 100));
};

export default initContentHubPage;
